import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export default function CategoryCard({ slug, name, icon, description }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="group flex flex-col items-center text-center p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 mb-3">
        <i className={`${icon} text-xl`}></i>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">{name}</h3>
      <p className="text-xs text-foreground-500 leading-relaxed">{description}</p>
    </Link>
  );
}